import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-luxon';

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function GraficaHistorica({ datos, tipo }) {
  const datosFiltrados = datos.filter(d => d.Tipo?.toLowerCase() === tipo);

  const data = {
    labels: datosFiltrados.map(d => d.FechaHora),
    datasets: [{
      label: tipo,
      data: datosFiltrados.map(d => d.Valor),
      fill: false,
      borderColor: '#00c4b3',
      tension: 0.3
    }]
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        type: 'time',
        time: { unit: 'hour' },
        title: { display: true, text: 'Hora' }
      },
      y: {
        title: { display: true, text: 'Valor' }
      }
    },
    plugins: {
      legend: { display: true },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.dataset.label}: ${ctx.parsed.y}`
        }
      }
    }
  };

  return <Line data={data} options={options} />;
}
